import { useEffect, useState } from "react"
import { TableDataV2 } from "@/components/common/Tablev2"
import { Protected } from "@/components/layout/Protected"
import { Container } from "@mui/material"
import { PhasesService } from "@/service/services/Phases.service"
import { Loading } from "@/components/common/Loading"
import { ModalPhases } from "@/components/Modal/ModalPhases"
import { ModalPhaseDelete } from "@/components/Modal/ModalPhaseDelete"
import { Props } from "./ContractDocuments.type"
import { ContractService } from "@/service/services/Contract.service"
import { useHistory } from "react-router-dom"
import { ROUTE_CREATE_CONTRACT_DOCUMENT, ROUTE_CUSTOMIZE_CONTRACT } from "@/toolbox/constants/route-map"

export const ContractDocumentsView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [documents, setDocuments] = useState([]);
    const [actionSelected, setActionSelected] = useState<any>('');
    const [documentSelected, setDocumentSelected] = useState<any>('');
    const [showEditDocument, setShowEditDocument] = useState<boolean>(false);

    console.log(actionSelected);

    const history = useHistory();

    useEffect(() => {
        if(actionSelected && actionSelected=='helper') showClauses('byContract');
    }, [actionSelected && actionSelected=='helper']);


    useEffect(() => {
        if(actionSelected && actionSelected=='save') showClauses('new');
    }, [actionSelected && actionSelected=='save']);

    useEffect(() => {
        documentContractText();
    }, []);

    const documentContractText = async() => {
        setLoading(true);
        await ContractService.documentContractText().then((data) => {
            setDocuments(data.data || []);
            setLoading(false);
        })
    }

    function RecuperarData(value){
        setDocumentSelected(value)
    }

    const showClauses = (type) => {
        if(type == 'byContract'){
            history.push(ROUTE_CUSTOMIZE_CONTRACT, {idEmployee: '13', idContractDocument: documentSelected?.id})
        }else{
            history.push(ROUTE_CREATE_CONTRACT_DOCUMENT, {})
        }
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>
                <TableDataV2
                    title={'Documentos Contrato'}
                    data={documents || []}
                    header={[
                        { name: 'name', label: 'Nombre', filter: false, Chip: false },
                        { name: 'description', label: 'Descripción', filter: false, Chip: true },
                    ]}
                    actionSelect={setActionSelected}
                    setModalSave={setShowEditDocument}
                    status_action
                    btn_delete_disable
                    btn_edit_disable
                    btn_helper
                    RecuperarData={RecuperarData}
                />
            </Container>
        </Protected>
    )
}